'use client';

import { SubprofileType } from '@vimond/services/subprofile';
import { createContext, ReactNode, useEffect, useState } from 'react';

export type SubprofileContextType = {
  app: 'web' | 'mobile' | 'ctv';
  subprofileToken?: string;
  activeSubprofile?: SubprofileType;
  setSubprofileToken: (subprofileToken: string) => void;
  setActiveSubprofile: (subprofile: SubprofileType) => void;
  isSelected: boolean;
};
export const SubprofileContext = createContext<SubprofileContextType | null>(
  null,
);

export const SubprofileProvider = ({
  app,
  children,
}: {
  app: 'web' | 'mobile' | 'ctv';
  children: ReactNode;
}) => {
  const [subprofileToken, setSubprofileToken] = useState<string | undefined>();
  const [activeSubprofile, setActiveSubprofile] = useState<
    SubprofileType | undefined
  >();
  useEffect(() => {
    if (app !== 'web') return;

    // get subprofile from cookie
    const cookie = document.cookie;
    // find cookie with name 'subprofile' in cookie string
    const subprofileCookie = cookie
      .split('; ')
      .find((row) => row.startsWith('subprofile'));
    const payload = subprofileCookie?.split('=')[1];
    const subprofile =
      subprofileCookie && payload
        ? (JSON.parse(payload) as SubprofileType)
        : undefined;
    setActiveSubprofile(subprofile);

    // find cookie with name 'subprofile_token' in cookie string
    const subprofileTokenCookie = cookie
      .split('; ')
      .find((row) => row.startsWith('subprofile_token'));
    const subprofileTokenPayload = subprofileTokenCookie?.split('=')[1];
    const subprofileToken =
      subprofileTokenCookie && subprofileTokenPayload
        ? (JSON.parse(subprofileTokenPayload) as string)
        : undefined;
    setSubprofileToken(subprofileToken);
  }, [app]);

  return (
    <SubprofileContext.Provider
      value={{
        app,
        subprofileToken,
        activeSubprofile,
        setSubprofileToken,
        setActiveSubprofile,
        isSelected: !!subprofileToken,
      }}
    >
      {children}
    </SubprofileContext.Provider>
  );
};
